import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Container } from '@/components/Container';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';

export const HeadingWrapper = styled(Container)`
  ${({ theme }) =>
    css`
      margin-bottom: ${theme.spacing(3)};
      ${theme.media.md.up} {
        margin-bottom: ${theme.spacing(4)};
      }
    `}
`;

export const ProductCardWrapper = styled(Box)`
  height: 100%;
`;

export const DiscoverButton = styled(LegacyButton)``;

export const ButtonWrapper = styled(Box)`
  text-align: center;
  margin: ${({ theme }) => theme.spacing(3)} ${({ theme }) => theme.spacing(2)}
    ${({ theme }) => theme.spacing(3)};
  ${({ theme }) =>
    css`
      ${theme.media.md.up} {
        margin: ${({ theme }) => theme.spacing(4)} auto;
        padding: 0;
      }
    `}
`;

export const Wrapper = styled(Flex)``;
